<template>
  <div id="about" class="about-wrap style6 pb-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-right"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="about-img-wrap">
            <img src="../../assets/images/about/about-img-13.jpg" alt="Image" />
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="about-content">
            <div class="content-title style4">
              <span>About Us</span>
              <h2>
                We Provide Special Care Through Our
                <span>Certified &amp; Experience</span> Doctors
              </h2>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using amet has.
              </p>
            </div>

            <div class="feature-item-wrap">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-makeup"></i>
                </div>
                <div class="feature-text">
                  <h5>Leading Plastic Surgery Center</h5>
                  <p>
                    Vestibulum ac diam sit amet quam vehicula elemen tum sed sit
                    amet dui praesent sapien pellen tesque .
                  </p>
                </div>
              </div>

              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-hot-stones"></i>
                </div>
                <div class="feature-text">
                  <h5>Online Appointment For Remote</h5>
                  <p>
                    Vestibulum ac diam sit amet quam vehicula elemen tum sed sit
                    amet dui praesent sapien pellen tesque.
                  </p>
                </div>
              </div>

              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-cosmetics"></i>
                </div>
                <div class="feature-text">
                  <h5>Special Services At Low Cost</h5>
                  <p>
                    Vestibulum ac diam sit amet quam vehicula elemen tum sed sit
                    amet dui praesent sapien pellen tesque.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>